import React from 'react';

/* _frfr-universal-components UNICOMPO UNIVERSAL SMALL ELEMENTS/COMPONENTS */
/*
PROPS:
props.size
props.extraClass
*/
/*
Separators widget adds a line break to your form to help improve your form.
*/

const UniFormcompoSeparator = (props) => {
  let cl = '';
  if (props.size > 0 || props.size === 0) {
    cl = ' uniformcompo__separator__line-core--' + props.size + 'px';
  }
  let extraClass = '';
  if (typeof props.extraClass === 'string') {
    extraClass = ' ' + props.extraClass;
  }
  return (
    <div className={"uniformcompo__separator" + extraClass}>
      <div className="uniformcompo__separator__line-core"></div>
    </div>
  );
};

export default UniFormcompoSeparator;